/* eslint-disable */
const getters = {
  getColor(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
